<template>
  <div class="examdetails">
    <!-- 页面位置提示 -->
    <div class="ymessage">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path:pathop }">{{ breadtitle }}</el-breadcrumb-item>
        <el-breadcrumb-item>资源详情</el-breadcrumb-item>
        <el-breadcrumb-item>{{ detailsDate.material.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 资料详情 -->
       <xunDetails :detailsDate="detailsDate" :readingone="readingone" :readingtwo="readingtwo"></xunDetails>
        <div class="operation" v-if="roustatus==0 && detailsDate.material.status==0">
          <div>
            <el-popover
              popper-class="opinion"
              
              placement="bottom"
              width="200"
              trigger="click">
              <div class="popwarp">
                <el-button class="button-new-tag" size="small" @click="listDept">+ 选择用户</el-button>
                <div class="notes">
                  <i>注：</i>
                  <span>1.不选择则全部可看。</span>
                </div>

              </div>
              <el-button type="primary" slot="reference">通过</el-button>
            </el-popover>

            <el-popover
              popper-class="opinion"
              
              placement="bottom"
              title="原因"
              width="360"
              trigger="click"
            >
              <div class="popwarp">
                <el-checkbox-group v-model="form.checkList" @change="changebox">
                  <ul class="check_box">
                    <li v-for="(item, index) in checkList" :key="index">
                      <el-checkbox :label="item"></el-checkbox>
                    </li>
                  </ul>
                </el-checkbox-group>
                <el-radio label="1" v-model="radio1" @change="changeqita">其他问题</el-radio>
                <div v-if="radio1==1" class="inpt_qita">
                  <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="请描述问题"
                    v-model="form.content"
                  >
                  </el-input>
                </div>

                <div class="btnnosh">
                  <el-button type="primary" @click="examshno()">确 定</el-button>
                </div>
              </div>
              <el-button style="background-color: red;" type="danger" slot="reference">不通过</el-button>
            </el-popover>
          </div>
        </div>
        <div v-if="detailsDate.material.status==1&&(roustatus==22||roustatus==999)" class="operation">
          <div style="margin-top: 8px; font-size: 18px">
            <i class="el-icon-circle-close" style="color: #f40"></i>
            <span>审核不通过</span>
          </div>
          <div>
            <el-button type="primary" @click="handleupdataFile">修改</el-button>
          </div>
        </div>
        <div  class="operation" v-if="detailsDate.material.status==0&&(roustatus==11 || roustatus==999)">
          <div style="margin-top: 8px; font-size: 18px">
            <span style="color: #E6A23C">审核中.....</span>
          </div>
          <div>
            <el-button  @click="handleupdataFile">修改</el-button>
          </div>
        </div>
         <div v-if="detailsDate.material.status==2&&(roustatus==999 ||roustatus == 111)" class="operation">
          <div style="margin-top: 8px; font-size: 18px">
            <span style="color: #67C23A">审核已通过</span>
          </div>
          <div>
            <el-button type="primary" @click="handleupdataFile">修改</el-button>
          </div>
        </div>
        <div v-if="roustatus==0&& detailsDate.material.status==2" class="operation">
          <div style="margin-top: 8px; font-size: 18px">
            <span style="color: #E6A23C">审核已通过</span>
          </div>
        </div>
        <div v-if="roustatus==0&& detailsDate.material.status==1" class="operation">
          <div style="margin-top: 8px; font-size: 18px">
            <span style="color: #f40">审核不通过</span>
          </div>
        </div>
    <div class="reason" v-if="roustatus==2||roustatus==22">
      <span class="title">原因:</span>
      <span class="content" v-for="(items,indexs) in bhyin" :key="indexs">
        {{ indexs + 1 }}.{{ items.reason }}
      </span>
    </div>

    <el-dialog
      title="选择用户"
      :close-on-click-modal="false"
      :visible.sync="userVisible"
      width="80%"
    >
      <div class="deptTable">
        <div style="width: 360px;float: left" class="typeA">
          <el-table
            height="600"
            v-if="refreshTable"
            v-loading="loading"
            :data="deptList"
            row-key="deptId"
            :default-expand-all="isExpandAll"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          >
            <el-table-column prop="deptName" label="选择部门" width="200">
              <template slot-scope="scope">
                <span @click="getUserList(scope.row)" style="color:#1890FF;cursor: pointer;">{{
                    scope.row.deptName
                  }}</span>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div style="width: 380px; float: left;margin-left: 80px">
          <p>部门人员</p>
          <div style="width: 380px; float: left">
            <el-table
              ref="deptUserTable"
              v-loading="loading"
              :data="deptUserList"
              row-key="userId"
              height="290"
              border
              @selection-change="handleSelectionDept"
            >
              <el-table-column type="selection" width="55" align="center"/>
              <el-table-column prop="userId" label="用户编号" width="100"></el-table-column>
              <el-table-column prop="nickName" label="用户昵称" width="100"></el-table-column>
              <el-table-column prop="dept.deptName" label="部门名称" width="100"></el-table-column>
            </el-table>
          </div>
          <div style="width: 380px; float: left">
            <p>其他人员</p>
            <el-table
              ref="noDeptUserTable"
              :data="noDeptUserList"
              row-key="userId"
              height="290"
              border
              @selection-change="handleSelectionOther"
            >
              <el-table-column type="selection" width="55" align="center"/>
              <el-table-column prop="userId" label="用户编号" width="100"></el-table-column>
              <el-table-column prop="nickName" label="用户昵称" width="100"></el-table-column>
              <el-table-column prop="dept.deptName" label="部门名称" width="100"></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="selectAll">
          <el-button-group>
            <el-button type="primary" @click="toLeft" style="width: 95px;margin-bottom: 20px" icon="el-icon-arrow-left">
              移除
            </el-button>
            <el-button type="primary" @click="toRight" style="width: 95px">添加<i
              class="el-icon-arrow-right el-icon--right"></i></el-button>
          </el-button-group>
        </div>
        <div style="width: 380px;float: left;margin-left: 130px">
          <p>已选人员</p>
          <el-table
            :data="chooseUserList"
            row-key="userId"
            height="600"
            border
            @selection-change="handleSelectionSelected"
          >
            <el-table-column type="selection" width="55" align="center"/>
            <el-table-column prop="userId" label="用户编号" width="100"></el-table-column>
            <el-table-column prop="nickName" label="用户昵称" width="100"></el-table-column>
            <el-table-column prop="dept.deptName" label="部门名称" width="100"></el-table-column>
          </el-table>
        </div>
        <div style="float: right;margin: 20px 50px 0 0 ">
          <el-button type="primary" @click="examshenhe()">确定</el-button>
          <el-button @click="chooseUserCancel">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import DetailInfo from '../components/DetailInfo'
import xunDetails from "../components/xundetails.vue"
export default {
  name: "examdetails",
  data() {
    return {
      checkList: ['资源质量不合格', '涉及版权问题', '涉及敏感信息', '涉及政治问题', '涉黄涉暴问题'],
      user: true,
      form: {
        checkList: [],
        content: ''
      },
      detailsDate: {
        material: {
          title: "",
          pros: "",
          cons: "",
          description: "",
          mediaType: "",
          suffix: "",
          fileSize: "",
          createTime: "",
          reason: ""
        },
        user: {
          nickName: "",
          updates: "",
          avatar: "",
        },
        types: [
          {
            typeSmalls: "",
          },
        ],
        mediaType: "",
      },
      mediaInfo: [],
      materialId: null,
      radio1: 2,//单选
      roustatus: null,//代表从哪个列表进来的
      baseurl: this.$http.requrl,
      bhyin: [],//驳回原因
      // 面包屑导航
      breadtitle: '',
      pathop: '',
      userVisible: false,
      // 部门树选项
      deptList: [],
      // 重新渲染表格状态
      refreshTable: true,
      // 遮罩层
      loading: true,
      // 是否展开，默认全部展开
      isExpandAll: true,
      //此部门用户列表
      deptUserList: [],
      chooseDeptUserList: [],
      //无部门用户列表
      noDeptUserList: [],
      chooseNoDeptUserList: [],
      //已选用户列表
      chooseUserList: [],
      chooseIds: [],
      chooseUserIds: [],
      //待动列表
      leftDeptUserList: [],
      leftOtherUserList: [],
      rightUserList: [],
      // 实验资料
      readingone:[],
      readingtwo:[],
    };
  },
  components: {DetailInfo,xunDetails},
  created() {
    this.breadtitle = this.$route.query.title;
    switch (this.breadtitle) {
      case '我的作品':
        this.pathop = '/profile-core/works';
        break;
      case '作品审核':
        this.pathop = '/profile-core/examine';
        break;
      default:
        break;
    }
    this.getNoDeptUserList()
  },
  beforeMount() {
    this.materialId = this.$route.query.id;
    this.roustatus = this.$route.query.roustatus;
    this.filedetailsg();
  },
  mounted() {

  },
  methods: {
    formatUrl(url) {
      return url == null ? url : url.startsWith("/profile") ? this.baseurl + url : this.baseurl + "/profile/" + url
    },
    // 详情
    filedetailsg() {
      this.$http
        .get("/business/material/details?materialId=" + this.materialId + "&userId=" + this.$store.state.userdata.user.userId)
        .then((res) => {
          if (res.code == 200) {
            this.detailsDate = res.data;
            this.readingone = [];
            this.readingtwo = [];
            this.detailsDate.zykMaterialMenus.filter(val=>{
                if(val.type == 1){
                  this.readingone.push(val)
                }else if(val.type == 2){
                  this.readingtwo.push(val)
                }
               
            });
            this.mediaInfo = JSON.parse(this.detailsDate.material.mediaInfo);
            this.bohuiyuanyin(this.detailsDate.material.id);
           
          }
        });
    },
    //通过
    examshenhe() {
      this.$confirm("确认是否通过", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.chooseUserList.forEach(row => {
          this.chooseUserIds.push(row.userId);
        })
        this.userVisible = false
        this.examdyes(2);
      }).catch(() => {

      });
    },
    //不通过
    examshno() {
      if (this.form.content == '' && this.radio1 == 1) {
        this.$message({
          message: "请描述不通过的原因",
          type: "warning"
        });
        return;
      }
      this.$confirm("确认是否该资源不通过", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.examdno(1);
      }).catch(() => {

      });

    },
    // 查询用户信息
    userdata() {
      this.$http.get("/system/user/myDetail").then(res => {
        if (res.code == 200) {
          let usdata = JSON.stringify(res.data);
          localStorage.setItem("userdata", usdata);
          if (localStorage.getItem("userdata")) {
            this.$store.commit('userdata', JSON.parse(localStorage.getItem("userdata")));
          }

        }
      });
    },
    // 审核通过
    examdyes(reviewResult) {
      let datas = {
        materialId: Number(this.materialId),
        reviewResult: reviewResult,
        viewUserIds: this.chooseUserIds
      }
      this.$http
        .post("/business/review", datas)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "审核通过",
              type: "success"
            });
            this.filedetailsg();
            this.userdata();
          }
        });
    },
    //审核不通过
    examdno(reviewResult) {
      let datas
      if (this.radio1 == 1) {
        datas = {
          materialId: Number(this.materialId),
          reviewResult: reviewResult,
          reason: this.form.content
        }
      } else {
        datas = {
          materialId: Number(this.materialId),
          reviewResult: reviewResult,
          reason: this.form.checkList.toString()
        }
      }
      this.$http
        .post("/business/review", datas)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "成功",
              type: "success"
            });
            this.filedetailsg();
            this.userdata();
          }
        });
    },
    //驳回原因选择
    changebox(val) {
      this.radio1 = 2;
    },
    changeqita(val) {
      this.form.checkList = [];
    },
    // 下一个资源
    lowermeaile() {

    },
    // 驳回原因
    bohuiyuanyin(id) {
      this.$http.get("/business/review/list?pageNum=1&pageSize=1&orderByColumn=createTime&isAsc=desc&materialId=" + id).then(res => {
        if (res.code == 200) {
          this.bhyin = res.rows;
        }
      })
    },
    base64encode(str) {
      var base64EncodeChars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var out, i, len;
      var c1, c2, c3;
      len = str.length;
      i = 0;
      out = "";
      while (i < len) {
        c1 = str.charCodeAt(i++) & 0xff;
        if (i == len) {
          out += base64EncodeChars.charAt(c1 >> 2);
          out += base64EncodeChars.charAt((c1 & 0x3) << 4);
          out += "==";
          break;
        }
        c2 = str.charCodeAt(i++);
        if (i == len) {
          out += base64EncodeChars.charAt(c1 >> 2);
          out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
          out += base64EncodeChars.charAt((c2 & 0xf) << 2);
          out += "=";
          break;
        }
        c3 = str.charCodeAt(i++);
        out += base64EncodeChars.charAt(c1 >> 2);
        out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
        out += base64EncodeChars.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
        out += base64EncodeChars.charAt(c3 & 0x3f);
      }
      return out;
    },
    handleupdataFile() {
      this.$router.push({path: '/updatafile', query: {id: this.materialId}})
    },
    // 选择可查看用户
    listDept() {
      this.loading = true;
      this.$http.get(`/system/dept/list?status=0`).then(res => {
        this.deptList = this.handleTree(res.data, "deptId");
        this.loading = false;
        this.userVisible = true;
      });
    },
    /** 展开/折叠操作 */
    toggleExpandAll() {
      this.refreshTable = false;
      this.isExpandAll = !this.isExpandAll;
      this.$nextTick(() => {
        this.refreshTable = true;
      });
    },
    /** 查询部门用户列表 */
    getUserList(row) {
      this.loading = true;
      this.$http.get(`/system/user/list?deptId=` + row.deptId).then(res => {
        this.deptUserList = res.rows
        this.loading = false;
      });
    },
    /** 查询其他用户列表 */
    getNoDeptUserList() {
      this.$http.get(`/system/user/noDeptUserList`).then(res => {
        this.noDeptUserList = res.rows
      });
    },
    //选择部门用户
    addUser(selection) {
      for (let i = 0; i < this.chooseUserList.length; i++) {
        if (this.chooseUserList[i].userId == selection.userId) {
          return false
        }
      }
      this.chooseUserList.push(selection);
    },
    //移除已选用户
    removeUser(row) {
      this.chooseUserList = this.chooseUserList.filter(item => item !== row)
    },
    chooseUserCancel() {
      this.chooseUserList = []
      this.userVisible = false
    },
//其他人员选择
    handleSelectionOther(otherSelect) {
      this.leftOtherUserList = otherSelect;
    },
    //部门人员选择
    handleSelectionDept(deptSelect) {
      this.leftDeptUserList = deptSelect;
    },
    handleSelectionSelected(selectedSelect){
      this.rightUserList = selectedSelect;
    },
    toRight() {
      var list = this.leftOtherUserList.concat(this.leftDeptUserList)
      for (let i = 0; i < list.length; i++) {
        this.chooseUserList.push(list[i]);
      }
      this.chooseUserList = this.unique(this.chooseUserList)
    },
    toLeft() {
      for (let i = 0; i < this.rightUserList.length; i++) {
        this.rightUserList.forEach(row => {
          this.chooseUserList = this.chooseUserList.filter(item => item !== row)
        })
      }
    },
    unique(arr) { // 根据唯一标识no来对数组进行过滤
      const res = new Map();  //定义常量 res,值为一个Map对象实例
      //返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
      return arr.filter((arr) => !res.has(arr.userId) && res.set(arr.userId, 1))
    },
  },
};
</script>
<style lang="scss" scoped>
.notes {
  color: #999999;
  position: relative;
  padding-left: 30px;
  line-height: 1.5;
  margin-top: 15px;

  i {
    position: absolute;
    left: 0;
    top: 0;
  }
}

.examdetails {
  background: #f7f7f7;
  position: relative;
  overflow: hidden;

  // 页面位置提示
  .ymessage {
    width: 1240px;
    margin: 0 auto;
    font-size: 18px;
    padding: 20px;
  }
      .operation {
        width: 150px;
        text-align: center;
        background: #fff;
        padding: 10px 0;
        position: fixed;
        right: 50px;
        top: 70%;
        border-radius:10px;
        .el-button {
          width: 90px;
          padding: 0;
          line-height: 30px;
          font-size: 18px;
          margin: 15px 0 6px 0;
          background-color: #50ddbb;
          border: #50ddbb;
          color: #fff;
        }
      }
    .detail_info {
      width: 286px;
      background: #fff;
      border-radius: 5px;
      overflow: hidden;
      padding: 24px 31px;
      padding-bottom: 0;
    }


  .reason {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    padding: 10px;
    margin-bottom: 10px;
    display: flex;

    .title {
      width: 50px;
      font-size: 18px;
      color: #999999;
    }

    .content {
      flex: 1;
      font-size: 16px;
      color: #666666;
    }
  }

}

.popwarp {

  .btnnosh {
    width: 110px;
    margin: 0 auto;

  }

  .check_box {
    li {
      display: inline-block;
      width: 50%;
      padding: 10px 5px;
    }
  }

  .inpt_qita {
    margin: 10px 0 10px 0;
  }
}

.deptTable {
  overflow: hidden;
}
.typeA{
  ::v-deep table td.el-table__cell {
    border-bottom: none !important;
  }
}
.selectAll {
  width: 100px;
  height: 100px;
  float: left;
  position: absolute;
  top: 50%;
  left: 57%;
}
</style>
